import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import EmailIcon from '../../assets/icons/Emails, Letter, Mail.png';
import FacebookIcon from '../../assets/icons/Facebook.png';
import AppleIcon from '../../assets/icons/Apple.png';
import AuthWrapper from '../../common/AuthWrapper';
import CustomSocialMediaButton from '../../common/CustomSocialMediaButton';
import { useIsMobile } from '../../hooks/useWindowWidth';
import GoogleButton from '../../common/GoogleButton/GoogleButton';

import styles from './SignIn.module.scss';

const SignIn: FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const uuid = crypto.randomUUID();

  const handleFacebook = async () => {
    try {
      const res = await fetch(`https://api-dev.travgenius.ai/users/sign-in/facebook/uri/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          state: uuid,
        }),
      });

      if (!res.ok) {
        throw new Error('Failed to fetch redirect URL');
      }

      const data = await res.json();
      const redirectUrl = data.url;

      window.location.href = redirectUrl;
    } catch (error) {
      console.error('Facebook redirect error:', error);
    }
  };

  return (
  <AuthWrapper btnName='Sign Up'>
    <Box className={styles.signInContent}>
      <Typography variant={`${isMobile ? 'h6Bold' : 'h5Bold'}`} className={styles.title}>Login</Typography>
      <CustomSocialMediaButton
        customStyle={styles.emailButton}
        text='Continue with Email'
        icon={EmailIcon}
        onClick={() => navigate('/login')}
      />
      <Box className={styles.signInText}>
        <Box className={styles.dividerLine}></Box>
        <Typography variant='h12' className={styles.dividerText} >OR</Typography>
        <Box className={styles.dividerLine}></Box>
      </Box>
      <Box className={styles.socialMediaButtons}>
        <CustomSocialMediaButton
          customStyle={styles.socialMediaButton}
          text='Continue with Facebook'
          icon={FacebookIcon}
          onClick={handleFacebook}
        />
        <GoogleButton />
        <CustomSocialMediaButton
          customStyle={styles.socialMediaButton}
          text='Continue with Apple'
          icon={AppleIcon}
          onClick={() => console.log('Continue with Apple')}
        />
      </Box>
      <Box className={styles.signUpQuestion}>
        <Typography variant='h11' className={styles.signUpQuestionText}>Don't have an account?</Typography>
        <Link to='/sign-up' className={styles.signUpLink}>
          <Typography variant='h11Semibold'>Sign Up</Typography>
        </Link>
      </Box>
    </Box>
  </AuthWrapper>
)};

export default SignIn;
